import { useCallback } from 'react';
import { useSetRecoilState } from 'recoil';
import { helpDeskSidePanel, helpDeskTicketsListState } from '@ubeya/shared/atoms/shared';
import { HELP_DESK_VIEW_VALUES } from '@ubeya/shared/constants/helpDesk';

/**
 * Opens the global Help Desk side panel focused on a given ticket and resets the list view to ALL
 * so the ticket is visible in the list behind the detail. Used by the side panel itself after a
 * create, and from places outside it (e.g. the employee profile actions menu) so a freshly created
 * ticket surfaces in the side panel.
 */
const useOpenTicketInSidePanel = () => {
  const setPanelState = useSetRecoilState(helpDeskSidePanel);
  const setListState = useSetRecoilState(helpDeskTicketsListState);

  return useCallback(
    (ticketId) => {
      if (!ticketId) return;
      setListState((s) => ({ ...s, view: HELP_DESK_VIEW_VALUES.ALL }));
      setPanelState({ isOpen: true, ticketId });
    },
    [setListState, setPanelState]
  );
};

export default useOpenTicketInSidePanel;
